import { render, staticRenderFns } from "./UpgradePlanPage.vue?vue&type=template&id=590c4683&"
import script from "./UpgradePlanPage.vue?vue&type=script&lang=js&"
export * from "./UpgradePlanPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports